<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card>
        <b-card-body>
          <b-row>
            <b-col
              md="5"
              lg="5"
              offset-md="3"
              offset-lg="3"
              class="fields-custom border"
            >
              <b-alert
                v-if="errorMsg"
                variant="warning"
                show
              >
                <div class="alert-body mt-1">
                  <span v-if="errorMsg">{{ errorMsg }}</span>
                </div>
              </b-alert>
              <b-row>
                <b-col
                  md="5"
                  lg="5"
                  offset-lg="4"
                  class="mt-2"
                >
                  <b-form-group
                    label="isFlypenge?"
                  >
                    <b-form-radio-group
                      v-model="isFlypenge"
                      :options="radioOptions"
                      value-field="item"
                      text-field="name"
                      class="demo-inline-spacing"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  md="5"
                  lg="5"
                  offset-lg="4"
                  class="mt-1"
                >
                  <b-form-group
                    label="LimitByCountry?"
                  >
                    <b-form-radio-group
                      v-model="LimitByCountry"
                      :options="radioOptions"
                      value-field="item"
                      text-field="name"
                      class="demo-inline-spacing"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row
                v-if="LimitByCountry === 'true'"
              >
                <b-col
                  md="5"
                  lg="6"
                  offset-lg="4"
                  class="mt-1"
                >
                  <b-form-group
                    label="LimitByCountry"
                  >
                    <v-select
                      v-model="country"
                      :options="countrySelection"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      class="custom-vselect"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="countrySelection"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  md="6"
                  lg="6"
                  offset-lg="4"
                  class="mt-1 mb-2"
                >
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    block
                    @click="SubmitExportData"
                  >
                    {{ $t('DEBTIA_SUBMIT') }}
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BCardBody, BOverlay, BRow, BCol, BFormGroup, BFormRadioGroup, BButton, BAlert,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import '@/@core/scss/vue/libs/vue-select.scss'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
import constants from '@/app-configs/constants'

export default {
  name: 'DataExport',
  components: {
    BCard,
    BCardBody,
    BOverlay,
    BRow,
    BAlert,
    BCol,
    BFormGroup,
    BFormRadioGroup,
    vSelect,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      LimitByCountry: '',
      loader: false,
      isFlypenge: '',
      country: '',
      errorMsg: '',
      countrySelection: [
        {
          label: 'Austria',
          value: 'Austria',
        },
        {
          label: 'Belgium',
          value: 'Belgium',
        },
        {
          label: 'Bulgaria',
          value: 'Bulgaria',
        },
        {
          label: 'Denmark',
          value: 'Denmark',
        },
        {
          label: 'Germany',
          value: 'Germany',
        },
        {
          label: 'Italy',
          value: 'Italy',
        },
        {
          label: 'Netherlands',
          value: 'Netherlands',
        },
        {
          label: 'Romania',
          value: 'Romania',
        },
        {
          label: 'Spain',
          value: 'Spain',
        },
        {
          label: 'Sweden',
          value: 'Sweden',
        },
        {
          label: 'Ireland',
          value: 'Ireland',
        },
        {
          label: 'Hungary',
          value: 'Hungary',
        },
        {
          label: 'Turkey',
          value: 'Turkey',
        },
        {
          label: 'Portugal',
          value: 'Portugal',
        },
        {
          label: 'Serbia',
          value: 'Serbia',
        },
        {
          label: 'Norway',
          value: 'Norway',
        },
        {
          label: 'France',
          value: 'France',
        },
      ],
      radioOptions: [
        { item: 'true', name: 'True' },
        { item: 'false', name: 'False' },
      ],
    }
  },
  watch: {
    '$i18n.locale': 'getCountries',
  },
  created() {
    // this.getCountries()
  },
  methods: {
    // getCountries() {
    //   const url = '/settings/get-countries-dropdown'
    //   axios.get(url).then(response => {
    //     if (response.status === 200) {
    //       this.countrySelection = this.$i18n.locale === 'en'
    //         ? response.data.data.en
    //         : response.data.data.da
    //     }
    //   })
    // },
    SubmitExportData() {
      this.loader = true

      const url = `${constants.baseUrl}/data-export?isFly=${this.isFlypenge}&limitByCountry=${this.LimitByCountry}&country=${this.country}`

      axios.get(url)
        .then(response => {
          if (response.status === 200 && response.data?.url) {
            this.loader = false
            this.errorMsg = ''
            const fileUrl = response.data.url

            const link = document.createElement('a')
            link.href = fileUrl
            link.setAttribute('download', 'data-export.csv')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        })
        .catch(e => {
          this.loader = false
          this.errorMsg = e.message
        })
    },
  },
}
</script>

<style>
.fields-custom{
    border: 1px solid #f8f8f8;
    border-radius: 15px;
}
</style>
